import Column from "@Containers/components/Column";
import Translation from "@Translation/components/Translation";
import React from "react";

interface DepartureStationPopoverOverlayProps {
    routeId: number,
    departureStation: string,
}

function DepartureStationPopoverOverlay({routeId, departureStation}: DepartureStationPopoverOverlayProps) {
    return (
        <>
            <Column>
                <Translation translationKey="sys.route"/>
                <span className="gb--emphasize-success">
                    {routeId}
                </span>
            </Column>
            <Column>
                <Translation translationKey="sys.departure"/>
                <span className="gb--truncate gb--emphasize-success">
                    {departureStation}
                </span>
            </Column>
        </>
    )
}

export default DepartureStationPopoverOverlay